import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Money = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="money icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M14 2C14 0.89543 13.1046 0 12 0C10.8954 0 10 0.89543 10 2V2.75806C9.21258 2.97142 8.46585 3.32288 7.81678 3.83372C6.58212 4.80546 5.83333 6.25916 5.83333 8C5.83333 9.03764 6.08129 9.96963 6.57691 10.7635C7.06658 11.5478 7.72498 12.081 8.37121 12.4456C9.44305 13.0505 10.6984 13.2883 11.3864 13.4186C11.4687 13.4341 11.543 13.4482 11.6078 13.4612C12.3899 13.6176 13.3329 13.8206 14.0773 14.2419C14.735 14.6142 15 14.9998 15 15.6111C15 16.1075 14.7945 16.5097 14.3412 16.8471C13.8478 17.2145 13.041 17.5 12 17.5C9.84626 17.5 9 16.2157 9 15.6111C9 14.5065 8.10457 13.6111 7 13.6111C5.89543 13.6111 5 14.5065 5 15.6111C5 18.572 7.33647 20.572 10 21.2474V22C10 23.1046 10.8954 24 12 24C13.1046 24 14 23.1046 14 22V21.2805C14.9965 21.0538 15.9324 20.6493 16.7298 20.0556C18.0862 19.0459 19 17.5036 19 15.6111C19 13.1114 17.515 11.5914 16.0477 10.7609C14.7032 9.99987 13.1913 9.69826 12.4502 9.55041L12.3922 9.53884C12.3129 9.52297 12.2354 9.50762 12.1598 9.49264C11.3837 9.33897 10.8002 9.22343 10.3371 8.96209C10.1292 8.84474 10.0272 8.73684 9.96996 8.6452C9.91871 8.56311 9.83333 8.38418 9.83333 8C9.83333 7.48842 10.0173 7.19212 10.2907 6.97696C10.6141 6.72236 11.1877 6.5 12 6.5C13.246 6.5 13.9459 7.08556 14.113 7.41181C14.6166 8.39491 15.8218 8.78364 16.8049 8.28006C17.788 7.77648 18.1767 6.57129 17.6731 5.58819C16.9439 4.16459 15.5627 3.20989 14 2.77296V2Z"
    />
  </svg>
)
